export default "__VITE_PUBLIC_ASSET__329c6b82__"